"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const AnchorLink = _ref => {
  let {
    label,
    href,
    newTab,
    ...rest
  } = _ref;
  if (newTab) {
    return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
      href: href,
      title: label,
      target: "_blank",
      rel: "noopener"
    }, rest), label);
  }
  return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    href: href,
    title: label
  }, rest), label);
};
AnchorLink.propTypes = {
  label: _propTypes.default.string,
  href: _propTypes.default.string,
  newTab: _propTypes.default.bool
};
var _default = exports.default = AnchorLink;